"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function accountAuthDescriptors(accountId) {
    return ['ft3.get_account_auth_descriptors', { id: accountId }];
}
exports.accountAuthDescriptors = accountAuthDescriptors;
function accountById(id) {
    return ['ft3.get_account_by_id', { id: id }];
}
exports.accountById = accountById;
function accountsByParticipantId(id) {
    return ['ft3.get_accounts_by_participant_id', { id: id }];
}
exports.accountsByParticipantId = accountsByParticipantId;
function accountsByAuthDescriptorId(id) {
    return ['ft3.get_accounts_by_auth_descriptor_id', { descriptor_id: id }];
}
exports.accountsByAuthDescriptorId = accountsByAuthDescriptorId;
//# sourceMappingURL=account-queries.js.map